// Javascript document for WordPress theme Adria Formation
'use strict';

// --- Integrations ---

import './integrations/bootstrap'; // integrates some bootstrap classes into wordpress
// import "./integrations/aos"  // required npm package: 'aos'
// import "./integrations/swiper"  // required npm package: 'swiper'

// --- Custom components ---
document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, '') + ' js';

/* Correction du bug des ancres sous Chrome
 * @see http://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
 * @see http://blog.atalan.fr/des-liens-devitement-astucieux/
 */
window.addEventListener('hashchange', function (event) {
  var element = document.getElementById(location.hash.substring(1));
  if (element) {
    if (!/^(?:a|select|input|button)$/i.test(element.tagName)) {
      element.tabIndex = -1;
    }
    element.focus();
  }
}, false);


/* Liens d’évitements > Persistance de l’affichage
 * @see http://blog.atalan.fr/des-liens-devitement-astucieux/
 */
[].forEach.call(document.querySelectorAll('.skip'), function(el) {
  el.addEventListener('focus', function() {
    el.classList.add('show');
  });
});

jQuery(document).ready(function() {

    // // Smooth Scrolling
    // // Select all links with hashes
    jQuery('a[href="#main"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                jQuery('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    var $target = jQuery(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });

    // jQuery for hover primary menu
    // jQuery('body').on('mouseenter mouseleave', '.dropdown', function (e) {
    //     var dropdown = jQuery(e.target).closest('.dropdown');
    //     var menu = jQuery('.dropdown-menu', dropdown);
    //     dropdown.addClass('show');
    //     menu.addClass('show');
        
    //     setTimeout(function () {
    //         dropdown[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
    //         menu[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
    //     }, 300);
    // });

    // jQuery('body').on('mouseenter mouseleave', '.dropdown', function (e) {
    //     var dropdown = jQuery(e.target).closest('.dropdown');
    //     var body = jQuery('body');
    //     var menu = jQuery('.dropdown-menu', dropdown);
    //     body.addClass('overlay-body');
        
    //     setTimeout(function () {
    //         body[dropdown.is(':hover') ? 'addClass' : 'removeClass']('overlay-body');
    //     }, 300);
    // });


    /**
     * Compatible drop-down menu issue.
     */
    var windowWidth = window.innerWidth;

    /**
     * Add active parent links on navigation
     */
    jQuery( '.navbar .dropdown > a' ).click(
        function () {
            //Do nothing if it's an empty hash.
            if ( jQuery( this ).attr( 'href' ) === '#' ) {
                return false;
            }
            location.href = this.href;
            return false;
        }
    );
    
        // Menu dropdown sur Desktop
        if ( matchMedia('screen and (min-width: 1200px)').matches ) {
        /**
         * Add Hover Dropdown
         */
        jQuery('.navbar .dropdown').hover(
            function() {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown().addClass('show');;
            },
            function() {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp().removeClass('show');;
            }
        );
    }
    else {
        /**
         * Always show sub-menu on the mobile screen
         */
        // $('.tablet .dropdown-menu').toggleClass('show');
    }



    // Search Icon with full screen
    // Open the full screen search box
    jQuery('a[href="#search"]').on('click', function(event) {
        event.preventDefault();
        jQuery('#search-overlay').toggleClass('active');
        jQuery('#searchform').addClass('active');
        jQuery('.search-field').focus();
        jQuery('body').addClass('blur');  // Overlay pour l'arrière plan
    });

    jQuery('#closebtn').on('click', function(event) {
        event.preventDefault();
        jQuery('#search-overlay').removeClass('active');
        jQuery('#searchform').removeClass('active');
        jQuery('.site').removeClass('blur');
    });

    jQuery('body').keyup(function(e) { // Même chose qu'au dessus mais au clavier sur ESC
        if (e.keyCode == 27) { // Code de la touche ESC du clavier
            jQuery('#search-overlay').removeClass('active');
            jQuery('#searchform').removeClass('active');
            jQuery('.site').removeClass('blur');
        }
    });


    // Ouverture d'un nouvel onglet pour les location.href avec ajout de la classe .external
    // https://stackoverflow.com/questions/1574008/how-to-simulate-target-blank-in-javascript
    jQuery('.external').click(function(e) {
        e.preventDefault();
        window.open(this.href);
    });

    // Bouton avec flèche à droite
    jQuery( '.arrow-white' ).append( '<span class="icon btn-arrow" role="img" aria-hidden="true"></span>' );

	// Update de la quantité sur le lien panier de la barre de navigation 
	jQuery('.woocommerce .products').on('click', '.quantity input', function() {
		return false;
	});
	jQuery('.woocommerce .products').on('change input', '.quantity .qty', function() {
		var add_to_cart_button = jQuery(this).parents( '.product' ).find('.add_to_cart_button');
		// For AJAX add-to-cart actions
		add_to_cart_button.data('quantity', jQuery(this).val());
		// For non-AJAX add-to-cart actions
		add_to_cart_button.attr('href', '?add-to-cart=' + add_to_cart_button.attr('data-product_id') + '&quantity=' + jQuery(this).val());
		add_to_cart_button.attr('data-quantity', jQuery(this).val()); // ajout
	});
    
	// Trigger on Enter press
	jQuery('.woocommerce .products').on('keypress', '.quantity .qty', function(e) {
		if ((e.which||e.keyCode) === 13) {
			jQuery( this ).parents('.product').find('.add_to_cart_button').trigger('click');
		}
	});

    // Toogle pour le formulaire de demand devis en dessous de la fiche de formation
    jQuery('#btn-toogle-quote-form').click(function() {
        jQuery('#intra-course-estimate-form').slideToggle('slow');
        jQuery(this).toggleClass('open');
    });


    // Toogle pour la zone de contact en sub-footer
    jQuery('#btn-toogle-form').click(function() {
        jQuery('.toogle-contact-form').slideToggle('slow');
        jQuery(this).toggleClass('open');
    });

    // Ajout class .active sur les caroussel Bootsrap
    // jQuery( '.carousel-item' ).first().addClass( 'active' );
    jQuery('.featured-course').slick({
        infinite: true,
        slidesToShow: 3,
        adaptiveHeight: true,
        rows: 0,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1
              }
            }
        ]
    });
});